<template>
    <!-- <b-form-group :label="label" :label-for="name">
        <b-form-radio-group v-model="valor" value-field="key" text-field="name" :name="name" :options="options"
            :disabled="disabled" @input="$emit('input', valor)" />
    </b-form-group> -->
    <v-radio-group
      v-model="model"
      dense
      row
      :disabled="disabled"
    >
    <v-radio
        v-for="opcao in items"
        :key="opcao.key"
        :label="`${opcao.name}`"
        :value="opcao.key"
      ></v-radio>
    </v-radio-group>
</template>


<script lang="ts">
import Vue from 'vue';


export default Vue.component('soi-radio', {
  props: {
    name: {
      type: String,
      default: '',
      required: false,
    },

    label: {
      type: String,
      default: '',
      required: false,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },

    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },

  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(novoValor) {
        this.$emit('input', novoValor);
      },
    },
  },

});
</script>
